module.exports = __webpack_public_path__ + "static/PFB__0001_Containers-edfa06f86f1c8887b66a1086790d50ae.png";